
import React from 'react';
import LoadingState from '@/components/LoadingState';
import { CrawlProgress } from '@/types/crawler';

interface LoadingContentProps {
  progress: CrawlProgress;
  onCancel: () => void;
  websiteUrl: string;
}

const LoadingContent: React.FC<LoadingContentProps> = ({
  progress,
  onCancel,
  websiteUrl
}) => {
  return (
    <div className="flex flex-col items-center justify-center pt-16" data-testid="dashboard-loading-container">
      <LoadingState 
        progress={progress.progress} 
        stage={progress.stage}
        pagesProcessed={progress.pagesProcessed}
        totalPages={progress.totalPages}
        onCancel={onCancel}
        websiteUrl={websiteUrl}
      />
    </div>
  );
};

export default LoadingContent;
